import {DefaultBtn, EmptyState} from "Ncontracts.Common.UI";
import PropTypes from "prop-types";
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {
    discardNewCommunication,
    dismissNewCommunicationErrorAlert,
    TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL
} from "../../../actions/communications/newCommunicationAction";
import {endLoading} from "../../../actions/globalAction";
import isEmpty from "../../../helpers/isEmpty";
import initialState from '../../../reducers/communications/initialState';
import ErrorAlert from "../../common/ErrorAlert";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import LoadingOverlay from "../../common/LoadingOverlay";
import NewCommunicationAddRecipientsModal from "./NewCommunicationAddRecipientsModal";
import NewCommunicationHeader from "./NewCommunicationHeader";
import NewCommunicationMessageForm from "./NewCommunicationMessageForm";
import NewCommunicationPollForm from "./NewCommunicationPollForm";
import NewCommunicationPreview from "./NewCommunicationPreview";
import NewCommunicationReplaceRecipientsWarning from "./NewCommunicationReplaceRecipientsWarning";
import NewCommunicationSelectedRecipients from "./NewCommunicationSelectedRecipients";

class NewCommunication extends Component {

    static propTypes = {
        communicationDraftSuccessfullySaved: PropTypes.bool,
        discardNewCommunication: PropTypes.func,
        dismissError: PropTypes.func,
        dispatchTransferComplete: PropTypes.func,
        history: PropTypes.object,
        match: PropTypes.object,
        message: PropTypes.string,
        newCommunicationSuccessfullySent: PropTypes.bool,
        selectedRecipients: PropTypes.array,
        showAddRecipientsModal: PropTypes.bool,
        showLoadingOverlay: PropTypes.bool,
        showErrorAlert: PropTypes.bool,
        showReplaceRecipientsWarning: PropTypes.bool,
        title: PropTypes.string,
        toggleModal: PropTypes.func,
        selectedContacts: PropTypes.array,
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);

        this.props.dispatchTransferComplete();
    }

    componentDidUpdate = () => {
        if (this.props.newCommunicationSuccessfullySent) {
            this.props.discardNewCommunication();
            this.props.history.push("/communications/sent");
        }
        if (this.props.communicationDraftSuccessfullySaved) {
            this.props.discardNewCommunication();
            this.props.history.push("/communications/saved");
        }
    };

    validateCurrentStep = currentStep => {
        if (currentStep !== 'recipients' && isEmpty(this.props.selectedRecipients)) {
            this.props.history.push('/communications/new');
        }
        if (currentStep === 'preview' && (isEmpty(this.props.title) || isEmpty(this.props.message))) {
            this.props.history.push('/communications/new/message');
        }
    };

    render() {
        const {dismissError, showAddRecipientsModal, showErrorAlert, showReplaceRecipientsWarning} = this.props;
        const currentStep = isEmpty(this.props.match.params.currentStep) ? 'recipients' : this.props.match.params.currentStep;
        this.validateCurrentStep(currentStep);

        const noRecipientsEmptyState =
            <EmptyState classes="no-recipients-empty-state"
                        imageAlt="No Recipients"
                        imageSrc={imageCdnUrls.new_user}
                        message="No Recipients"
                        button={<DefaultBtn onClick={this.props.toggleModal}>Add Recipients</DefaultBtn>}/>;

        const stateRecipients = this.props.selectedContacts != null && this.props.selectedContacts.length > 0 ?
            <NewCommunicationSelectedRecipients/> : noRecipientsEmptyState;

        const messageForm = currentStep === 'message' ? <NewCommunicationMessageForm/> : undefined;
        const pollForm = currentStep === 'poll' ? <NewCommunicationPollForm/> : undefined;
        const previewContainer = currentStep === 'preview' ? <NewCommunicationPreview/> : undefined;

        const pageBody = currentStep === 'recipients' ? stateRecipients :
                         currentStep === 'message' ? messageForm :
                         currentStep === 'poll' ? pollForm : previewContainer;

        return (
            <div className="communications-container">
                {this.props.showLoadingOverlay ? <LoadingOverlay/> : undefined}
                <div className="new-communication-container">
                    <NewCommunicationHeader/>
                    <div className="page-body">
                        {pageBody}
                        {(showReplaceRecipientsWarning) ? <NewCommunicationReplaceRecipientsWarning/> : undefined }
                        {(showAddRecipientsModal) ? <NewCommunicationAddRecipientsModal/> : undefined}
                        {(showErrorAlert) ? <ErrorAlert dismissHandler={dismissError}/> : undefined}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    communicationDraftSuccessfullySaved: state.newCommunication.communicationDraftSuccessfullySaved,
    message: state.newCommunication.message,
    newCommunicationSuccessfullySent: state.newCommunication.newCommunicationSuccessfullySent,
    selectedRecipients: state.newCommunication.selectedRecipients,
    showAddRecipientsModal: state.newCommunication.showAddRecipientsModal,
    showLoadingOverlay: state.newCommunication.posting,
    showReplaceRecipientsWarning: state.newCommunication.showReplaceRecipientsWarning,
    showErrorAlert: state.newCommunication.showErrorAlert,
    selectedContacts: state.newCommunication.selectedRecipients,
    title: state.newCommunication.title,
});

const mapDispatchToProps = dispatch => ({
    dismissError: () => dispatch(dismissNewCommunicationErrorAlert()),
    discardNewCommunication: () => dispatch(discardNewCommunication()),
    dispatchTransferComplete: () => dispatch(endLoading()),
    toggleModal: () => dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL}),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunication));
